import { TextField } from 'src/components/TextField';

import { LastCompletedVisitFilterOperator, VisitFilterOperator } from './_types';
import { VisitFilterSelectOption } from './constants';
import { useClientVisitFilterLabels } from './useClientVisitFilterLabels';

interface VisitFilterOperatorFieldProps {
  label?: string;
  value?: VisitFilterOperator;
  onChange: (operator: VisitFilterOperator | LastCompletedVisitFilterOperator | undefined) => void;
  error?: boolean;
  operators?: VisitFilterSelectOption<VisitFilterOperator>[];
}

export const VisitFilterOperatorField = ({
  label,
  value,
  onChange,
  error = false,
  operators: operatorsOverride,
}: VisitFilterOperatorFieldProps) => {
  const { comparisonLabel, operators: defaultOperators, selectPlaceholder } =
    useClientVisitFilterLabels();
  const operators = operatorsOverride ?? defaultOperators;

  return (
    <TextField
      label={label ?? comparisonLabel}
      value={value ?? ''}
      onChange={(e) => {
        const next = e.target.value as VisitFilterOperator;
        onChange(next || undefined);
      }}
      options={[
        { value: '', label: selectPlaceholder },
        ...operators.map((option) => ({
          value: option.value,
          label: option.label,
        })),
      ]}
      error={error}
    />
  );
};
